"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _newArrowCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/newArrowCheck"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ZForm = require("./ZForm");

var _excluded = ["zName", "zOptions"];

var _this = void 0;

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = (0, _getPrototypeOf2.default)(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2.default)(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var controllerDecorator = function controllerDecorator(options) {
  (0, _newArrowCheck2.default)(this, _this);
  return function decorator(Controller) {
    var _class, _temp;

    return _temp = _class = /*#__PURE__*/function (_Component) {
      (0, _inherits2.default)(WrappedController, _Component);

      var _super = _createSuper(WrappedController);

      function WrappedController() {
        (0, _classCallCheck2.default)(this, WrappedController);
        return _super.apply(this, arguments);
      }

      (0, _createClass2.default)(WrappedController, [{
        key: "render",
        value: function render() {
          var _this2 = this;

          var _this$props = this.props,
              zName = _this$props.zName,
              zOptions = _this$props.zOptions,
              controllerProps = (0, _objectWithoutProperties2.default)(_this$props, _excluded);
          var rules = (zOptions && zOptions.rules ? zOptions.rules : []).map(function (rule) {
            (0, _newArrowCheck2.default)(this, _this2);

            if (rule.validator) {
              var propValidator = rule.validator;
              return _objectSpread(_objectSpread({}, rule), {}, {
                validator: function validator(rule, value, callback) {
                  var _this3 = this;

                  for (var _len = arguments.length, args = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
                    args[_key - 3] = arguments[_key];
                  }

                  propValidator.apply(void 0, [rule, value, function (res) {
                    (0, _newArrowCheck2.default)(this, _this3);

                    if (res !== null) {
                      callback(res);
                    } else {
                      callback();
                    }
                  }.bind(this)].concat(args));
                }
              });
            } else {
              return rule;
            }
          }.bind(this));
          return /*#__PURE__*/_react.default.createElement(_ZForm.ZFormContext.Consumer, null, function (_ref) {
            (0, _newArrowCheck2.default)(this, _this2);
            var form = _ref.form;
            return form.getFieldDecorator(zName, _objectSpread(_objectSpread({}, options), _objectSpread(_objectSpread({}, zOptions), {}, {
              rules: rules
            })))( /*#__PURE__*/_react.default.createElement(Controller, controllerProps));
          }.bind(this));
        }
      }]);
      return WrappedController;
    }(_react.Component), _class.propTypes = {
      zName: _propTypes.default.string.isRequired,
      zOptions: _propTypes.default.any
    }, _temp;
  };
}.bind(void 0);

var _default = controllerDecorator;
exports.default = _default;